/**
 * @file LoginBackground.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Component used in Auth pages.
 */
import { Box } from "@mui/material";
import { images } from "../../assets";

export const AuthBackground = () => (
  <Box
    sx={{
      position: "absolute",
      right: 0,
      height: "100%",
      width: "70%",
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${images.loginBg})`,
    }}
  />
);
